// =============================================================
// PROFILE — your name, tagline, bio, and contact links.
// Edit these strings to update the About + Contact sections.
// =============================================================
export const profile = {
  name: "Alexander Sta Monica",
  tagline: "Computer Science · AI & Machine Learning",
  bio:
    "Computer Science (Honours) student at Carleton University specializing in " +
    "Artificial Intelligence & Machine Learning, and a Quality Assurance Engineer " +
    "at Deloitte. Fully bilingual (French & English), hackathon winner, and a builder " +
    "of practical AI tools who cares about clean, well-tested software.",
  contacts: [
    { type: "email", label: "Lexdsm31@gmail.com", href: "mailto:Lexdsm31@gmail.com" },
    {
      type: "linkedin",
      label: "LinkedIn",
      href: "https://linkedin.com/in/alexanderstamonica-347344390",
    },
    { type: "github", label: "Alexstamonica", href: "https://github.com/Alexstamonica" },
    { type: "phone", label: "613-795-2539", href: "tel:6137952539" },
  ],
};
